import { render, staticRenderFns } from "./LoadingSpin.vue?vue&type=template&id=1145f46c&"
import script from "./LoadingSpin.vue?vue&type=script&lang=js&"
export * from "./LoadingSpin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports